
import { PropType } from 'vue';
import VueI18n from 'vue-i18n';
import TranslateResult = VueI18n.TranslateResult;
/**
 * The `SwitchInput` component is similar in how the `Checkbox` component functions.
 * The main difference here is the styling of the component to look like a toggle slider.
 */
export default {
  name: 'SwitchInput',

  props: {
    checkedValue: {
      type: [String, Number, Boolean],
      default: true,
    },
    size: {
      type: String as PropType<'small' | 'large'>,
      default: 'large',
    },
    value: {
      type: [Array, String, Number, Boolean],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    labelText: {
      type: [String, TranslateResult],
      default: '',
    },
  },

  computed: {
    isChecked() {
      // Allow our checkbox to support v-model that can be an array (multiple checkbox values)
      // or just a single value, as per the examples of multiple checkboxes in the Vue documentation.
      return this.value instanceof Array
        ? this.value.includes(this.checkedValue)
        : this.value === this.checkedValue;
    },
  },

  methods: {
    toggle() {
      let newValue;
      const { value, checkedValue, isChecked } = this;
      if (value instanceof Array) {
        newValue = isChecked
          ? value.filter((v) => v !== checkedValue)
          : [...value, checkedValue];
      } else {
        // presumed to be a boolean
        newValue = !value;
      }
      this.$emit('input', newValue);
    },
  },
};
